import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import {} from "react";
import { Box, Drawer, List, ListItem, Stack, useTheme } from "@mui/material";
import { AppDrawerDivider } from "./AppDrawerItems.js";
export const AppDrawerDesktop = ({ drawerWidth = "15.625rem", logo, drawerItems, children, appDrawerColor, }) => {
    const theme = useTheme();
    return (_jsxs(Box, { sx: { display: "flex", flexDirection: "row" }, children: [_jsx(Drawer, { variant: "permanent", sx: { width: drawerWidth }, slotProps: {
                    paper: {
                        sx: {
                            width: drawerWidth,
                            backgroundColor: appDrawerColor ?? theme.palette.primary.main,
                            color: theme.palette.primary.contrastText,
                        },
                    },
                }, children: _jsxs(Stack, { component: "nav", "aria-label": "Main navigation", sx: { width: drawerWidth, flexGrow: 1 }, children: [_jsx(List, { children: _jsx(ListItem, { children: _jsx(Box, { sx: { display: "flex", flexGrow: 1, justifyContent: "center" }, children: logo }) }) }), _jsx(AppDrawerDivider, {}), _jsx(Box, { sx: { display: "flex", flexGrow: 1 }, children: drawerItems })] }) }), children] }));
};
//# sourceMappingURL=AppDrawerDesktop.js.map